var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUbaselogo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29.7803,
    r: 28.5,
    fill: "white",
    stroke: "#CACACA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2922_312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4968 6.78027L7 19.882V39.685L29.4968 52.7868L51.9935 39.685V19.882L29.4968 6.78027ZM48.2721 37.5145L29.5032 48.4457L10.7278 37.5145V22.0526L29.4968 11.1214L48.2657 22.0526V37.5145H48.2721Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2154 19.6139V23.1835L15.8052 25.171V28.7538L12.5117 30.6693V36.4291L29.4977 46.3208L46.4838 36.4291V23.3797L29.4848 13.4814L19.2089 19.6139H19.2154ZM29.4977 41.9797L16.2396 34.2586V32.8464L17.6659 32.0161L32.1429 40.4434L29.5042 41.9797H29.4977ZM32.7912 36.4814L19.533 28.7603V27.3416L21.076 26.4394L35.5531 34.8666L32.7912 36.4749V36.4814ZM42.7624 25.5502V26.982L36.1884 30.9047L22.9432 23.1901V21.7583L29.5172 17.8356L42.7624 25.5502Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2922_312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 46,
    fill: "white",
    transform: "translate(7 6.78027)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbaselogo2);
export default __webpack_public_path__ + "static/media/ubaselogo2.a5e05961b08fc6f8e9e568ea04f96f99.svg";
export { ForwardRef as ReactComponent };